import { render, staticRenderFns } from "./exploracionFisica.vue?vue&type=template&id=89cdb0a6&"
import script from "./exploracionFisica.vue?vue&type=script&lang=js&"
export * from "./exploracionFisica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports